<template>
  <div id="app" :class="[pcMode ? 'pc-style' : '', isIndex ? 'page-bottom' : '']">
    <keep-alive :include="included">
      <router-view id="page" />
    </keep-alive>
    <!-- <app-tabbar /> -->
    <van-tabbar v-if="isIndex" route active-color="#F13934" inactive-color="#262626">
      <van-tabbar-item to="/">
        <span>首页</span>
        <base-icon slot="icon" class="icon" :name="$route.name === 'home' ? 'home_active' : 'home'" />
      </van-tabbar-item>
      <van-tabbar-item to="/job">
        <span>零工大厅</span>
        <base-icon slot="icon" class="icon" :name="$route.name === 'job' ? 'job_active' : 'job'" />
      </van-tabbar-item>
      <van-tabbar-item @click="handlePublish">
        <span class="publish-tit">发布</span>
        <div slot="icon" class="publish-icon">
          <base-icon class="icon" name="tabbar_publish" />
        </div>
      </van-tabbar-item>
      <van-tabbar-item to="/resume">
        <span>零工人才</span>
        <base-icon slot="icon" class="icon"
                   :name="$route.name === 'resume' ? 'tabbar_talents_active' : 'tabbar_talents'"
        />
      </van-tabbar-item>
      <van-tabbar-item to="/mine">
        <span>我的</span>
        <base-icon slot="icon" class="icon" :name="$route.name === 'mine' ? 'mine_active' : 'mine'" />
      </van-tabbar-item>
    </van-tabbar>
    <van-popup v-model="publishPopup" round position="bottom" class="publishPopup">
      <div class="publish-popup">
        <div class="publish-popup_content">
          <div class="link-list">
            <div class="item service" @click="publish('service')">
              <div class="icon-wrap flex-center">
                <base-icon name="home_popup_talents" class="icon"></base-icon>
              </div>
              <div class="desc-wrap">
                <div class="tit">发布服务</div>
                <div class="subtit">服务入驻 随时随地接零活</div>
              </div>
              <div class="arrow-warp">
                <base-icon name="home_popup_arrow2" class="icon"></base-icon>
              </div>
            </div>
            <div class="item seek" @click="publish('oddPosition')">
              <div class="icon-wrap flex-center">
                <base-icon name="home_popup_job" class="icon"></base-icon>
              </div>
              <div class="desc-wrap">
                <div class="tit">发布零工</div>
                <div class="subtit">发布零工项目 快速招人</div>
              </div>
              <div class="arrow-warp">
                <base-icon name="home_popup_arrow" class="icon"></base-icon>
              </div>
            </div>
          </div>
        </div>
        <div class="publish-popup_footer" @click="publishPopup = false">取消</div>
      </div>
    </van-popup>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import authMixins from "@/mixins/auth";
export default {
  name: "App",
  mixins: [authMixins],
  data() {
    return {
      publishPopup: false,
    };
  },
  computed: {
    ...mapGetters(["webConfig", "pcMode", "included", "userType", "userInfo"]),
    isIndex() {
      return this.$route.meta.isIndex && this.webConfig.odd_jobs_application;
    },
  },
  created() {
    this.getConfig();
  },
  methods: {
    ...mapActions(["setRedirectUrl"]),
    async getConfig() {
      const res = await this.$api.getWebConfig();
      document.title = res.baseInfo.title;
    },
    async handlePublish() {
      if (this.userType === 1) {
        this.publishPopup = true;
      } else if (this.userType === 2) {
        this.companyAuth();
      } else {
        this.$router.push({ name: "login" });
      }
    },
    async companyAuth() {
      this.publishPopup = true;
      // if (this.webConfig.odd_jobs_is_talent) {
      //   this.publishPopup = true
      // } else {
      //   try {
      //     await this.companyPublishAuth('service')
      //     this.$router.push({ name: "servicePublish" })
      //   } catch (err) {
      //     // console.log(err)
      //   }
      // }
    },
    async handleCompanyPublish(type) {
      this.publishPopup = false;
      try {
        await this.companyPublishAuth(type);
        type === "service" && this.$router.push({ name: "servicePublish" });
        type === "oddPosition" && this.$router.push({ name: "oddPublish" });
      } catch (err) {
        // console.log(err)
      }
    },
    async publish(type) {
      this.publishPopup = false;
      try {
        if (this.userType === 1) {
          await this.personPublishAuth(type);
        } else if (this.userType === 2) {
          await this.companyPublishAuth(type);
        }
        type === "service" && this.$router.push({ name: "servicePublish" });
        type === "oddPosition" && this.$router.push({ name: "oddPublish" });
      } catch (err) {
        // console.log(err)
      }
    },
  },
};
</script>
<style lang="less">
body {
  margin: 0 auto !important;
  max-width: 750px;
}

#app {
  background: #f6f7f8;
  min-height: 100vh;
}

#page {
  position: relative;
}

.publish-popup {
  padding-bottom: constant(safe-area-inset-bottom);
  padding-bottom: env(safe-area-inset-bottom);

  &_content {
    padding: 60px;

    .link-list {
      display: flex;
      flex-direction: column;

      .item {
        width: 100%;
        border-radius: 16px;
        padding: 48px 20px 48px 40px;
        display: flex;
        flex-direction: row;
        align-items: center;

        &+.item {
          margin-top: 30px;
        }

        &.seek {
          background: #fef5f5;

          .icon-wrap {
            background: linear-gradient(135deg, #ff8a3f 0%, #fd5c60 100%);
          }
        }

        &.service {
          background: #f2fbf6;

          .icon-wrap {
            background: linear-gradient(135deg, #4bce78 0%, #08a86b 100%);
          }
        }

        .icon-wrap {
          border-radius: 32px;
          width: 84px;
          height: 84px;

          .icon {
            height: 48px;
            width: 48px;
          }
        }

        .desc-wrap {
          height: 84px;
          padding-left: 24px;
          display: flex;
          flex: 1;
          flex-direction: column;
          justify-content: space-between;

          .tit {
            font-weight: bold;
            color: #262626;
            font-size: 34px;
          }

          .subtit {
            color: #4d4d4d;
            font-size: 26px;
          }
        }

        .arrow-warp {
          .icon {
            height: 44px;
            width: 44px;
          }
        }
      }
    }
  }

  &_footer {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 120px;
    color: #666666;
    font-size: 32px;
    border-top: 20px solid #f1f2f6;
  }
}
</style>
